module.exports = __webpack_public_path__ + "img/embd-card.24f7c49c.png";